
const apiDataReducer = (state = [], action) => {
    switch(action.type){
        case 'API_DATA_STORE': 
            state = action.payload;  
            return state;
        case 'API_DATA_DESTROY':
              return state = []; 
        default:
              return state;

    }
};

export default apiDataReducer;